import type { ReactNode } from "react";
import { cn } from "@/v2/lib/utils";

interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  className?: string;
  /** Override the title's weight/spacing utilities (e.g. to match a page's pre-existing look). */
  titleClassName?: string;
  /** Override the subtitle's utilities (e.g. to match a page's pre-existing look). */
  subtitleClassName?: string;
}

/**
 * Shared title + subtitle block for v2 page tops (Account, Profile,
 * Favorites Manager, Access Center, ...). Default spacing/type scale is the
 * one from the Access Center page: 28px extrabold title, 4px gap, muted
 * subtitle. Callers that predate this component with a different weight or
 * spacing can override via titleClassName/subtitleClassName/className
 * instead of silently inheriting the default look.
 */
export function PageHeader({
  title,
  subtitle,
  className,
  titleClassName,
  subtitleClassName,
}: PageHeaderProps) {
  return (
    <div className={cn("mb-5", className)}>
      <h1
        className={cn("font-extrabold text-slate-900 mb-1", titleClassName)}
        style={{ fontSize: "28px", lineHeight: 1.2 }}
      >
        {title}
      </h1>
      {subtitle ? (
        <p className={cn("text-sm font-normal text-slate-500", subtitleClassName)}>
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}
